import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedHTMLMessage } from "react-intl";
import "./AssessmentRubric.scss";

import { parseData } from "./utils";
import messages from "./messages";

const AssessmentRubric = ({ data, editable, onSelectAlternative }) => {
  const { questions, headerAlternatives } = parseData(data);
  const handleSelectAlternative = ({alternative, question}) => {
    if (onSelectAlternative) {
      const alternativeId = Number(alternative.id);
      onSelectAlternative(alternativeId, question.idType, question.id);
    }
  }
  return (
    <div>
      <table border="1" className="assessment-rubric-table">
        <thead>
          <tr>
            <th>
              <FormattedHTMLMessage {...messages.questionHeader} />
            </th>
            {headerAlternatives.map((_, index) => (
              <th key={index}>
                <FormattedHTMLMessage
                  {...(messages[`alternative${index + 1}`] ?? messages.alternativeDefault)}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {questions.map(question => (
            <tr key={question.id}>
              <td>
                <div dangerouslySetInnerHTML={{ __html: question.html }}></div>
              </td>
              {question.alternatives.map(alternative => (
                <td key={alternative.id}>
                  {alternative.html && (
                    <input
                      type="radio"
                      name={`question-${question.id}`}
                      value={alternative.id}
                      disabled={!editable}
                      checked={alternative.checked}
                      onChange={() => handleSelectAlternative({ alternative, question })}
                    />
                  )}
                  <div dangerouslySetInnerHTML={{ __html: alternative.html }}></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

AssessmentRubric.propTypes = {
  data: PropTypes.object.isRequired,
  editable: PropTypes.bool,
};

export default AssessmentRubric;
